/**
 * Enable known referrer adoption feature * https:www.notion.so/faire/Known-Referrer-Adoption-86e0adc24c1e4d0ba85a1b77f91b8c65
 */
export const ENABLE_KNOWN_REFERRER_ADOPTION_230815 = 'ENABLE_KNOWN_REFERRER_ADOPTION_230815';
